import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

const SmashBuzzApi= {
  getTournaments : function(){
    let data = axios.get(API_URL+'/tweets/tournament_data')
      .then(response => {
        // id is required to use in DataGrid
        response.data.forEach((item, i) => {
          item.id=i;

          // making relevant data easier to access
          item.link = item._id;
          item.entrants=item.tournament_data[0].entrants;
          item.startAt = item.tournament_data[0].startAt;
          item.name = item.tournament_data[0].name;
        });
        return response.data;
      })
      .catch(function (error){
        console.log(error);
        throw error;
      });
    return data;
  }
}

export default SmashBuzzApi ;
